import { Dispatch, SetStateAction } from 'react';
import { Column } from 'react-table';

import { Button, ImportTable, Visible } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { AlignText, ButtonType, Size } from 'coreOld/enums';
import { IPreviewPart } from 'partsOld/types';

import {
  Buttons,
  Content,
  Header,
  tableBodyStyle,
  TableWrapper,
  Wrapper,
} from './previewModalStyle';
import UnkownManufacturerModal from './UnkownManufacturerModal';
import ChooseManufacturerModal from '../ChooseManufacturerModal';

interface IProps {
  isLoading: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  records: IPreviewPart[];
  columns: Column<object>[];
  fetchNextPage;
  goBack: () => void;
  isChooseManufacturerModalOpen: boolean;
  isIdentifyManufaturersOpen: boolean;
  setIsUnknownManufactures: Dispatch<SetStateAction<boolean>>;
  onImport: () => Promise<void>;
  partImport: number;
  refetchColumns;
  refetchValidateParts;
  unknownManufacturers: string[];
}

const PreviewModalView = ({
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  records,
  fetchNextPage,
  columns,
  goBack,
  onImport,
  isChooseManufacturerModalOpen,
  partImport,
  refetchColumns,
  refetchValidateParts,
  isIdentifyManufaturersOpen,
  setIsUnknownManufactures,
  unknownManufacturers,
}: IProps) => {
  return (
    <Content>
      <Header>
        <div></div>

        <Buttons>
          <Button
            onClick={goBack}
            btnType={ButtonType.ACTION_INVERTED}
            fullWidth={false}
            size={Size.SM}
          >
            Go back
          </Button>

          <Visible when={!isChooseManufacturerModalOpen || !isIdentifyManufaturersOpen}>
            <Button onClick={onImport} fullWidth={false} size={Size.SM}>
              Import Parts
            </Button>
          </Visible>
        </Buttons>
      </Header>

      <Wrapper>
        <TableWrapper>
          <ImportTable
            columns={columns}
            data={records}
            headerLines={2}
            name={TableNames.IMPORT_PREVIEW_ROWS}
            isLoading={isLoading}
            tableBodyStyle={tableBodyStyle}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
            hasFooter={true}
            textAlign={AlignText.LEFT}
          />
        </TableWrapper>
      </Wrapper>

      <UnkownManufacturerModal
        isOpen={isIdentifyManufaturersOpen}
        unknownManufacturers={unknownManufacturers}
        partImport={partImport}
        refetchValidateParts={refetchValidateParts}
      />

      <ChooseManufacturerModal
        isModalOpen={isChooseManufacturerModalOpen}
        setIsUnknownManufactures={setIsUnknownManufactures}
        importId={partImport}
        refetchColumns={refetchColumns}
      />
    </Content>
  );
};

export default PreviewModalView;
